import { IClassName } from '@frontend/jetlend-core/src/models/common';
import React, { PropsWithChildren } from 'react';
import maskChildNodes from '@frontend/jetlend-core/src/utils/maskChildNodes';
import { mergeClassNames } from '@ui/utils/classNameUtils';
import styles from './MaskWrapper.module.scss';

export interface IProps extends PropsWithChildren, IClassName {
    /**
     * Флаг включения / отключения маски
     */
    masked?: boolean;
}

export const NUMBER_MASK_CHAR = '0';
export const UPPERCASE_LETTER_CHAR = 'Z';
export const LOWERCASE_LETTER_CHAR = 'z';
export const NUMBER_REGEX = /\d/;
export const LETTERS_AND_NUMBERS_REGEX = /[a-zA-Z0-9]/g;

/**
 * Заменяет числовые и буквенные символы в строке на маску
 */
function maskText(text: string) {
    return text.replace(LETTERS_AND_NUMBERS_REGEX, (char) => {
        if (NUMBER_REGEX.test(char)) {
            return NUMBER_MASK_CHAR;
        }
        if (char === char.toUpperCase()) {
            return UPPERCASE_LETTER_CHAR;
        }
        return LOWERCASE_LETTER_CHAR;
    });
};

/**
 * Маскирует дочерние элементы.
 * Заменяет числовые и буквенные символы в дочерних элементах на маску.
 */
export default function MaskWrapper({
    masked = true,
    className,
    children,
}: IProps) {

    const processedChildren = maskChildNodes(children, maskText);

    return (
        <div
            className={mergeClassNames([
                styles['mask-wrapper'],
                masked && styles['mask-wrapper--blur'],
                !masked && styles['mask-wrapper--unblur'],
                className,
            ])}
        >
            {masked ? processedChildren : children}
        </div>
    );
}